const MUTATE_CAMPAIGNS = `campaigns:mutate`
const MUTATE_BUDGET = `campaignBudgets:mutate`
const MUTATE_AD_GROUPS = `adGroups:mutate`
const MUTATE_AD_GROUP_ADS = `adGroupAds:mutate`
const MUTATE_AD_GROUP_CRITERIA = `adGroupCriteria:mutate`
const MUTATE_ADS = `ads:mutate`

export default {
  MUTATE_CAMPAIGNS,
  MUTATE_BUDGET,
  MUTATE_AD_GROUPS,
  MUTATE_AD_GROUP_ADS,
  MUTATE_AD_GROUP_CRITERIA,
  MUTATE_ADS
}
